module.exports = __webpack_public_path__ + "img/Budget.244e377d.svg";